/* eslint-disable no-undef */
/* eslint-disable import/no-anonymous-default-export */
import React, { Fragment, useContext, useEffect, useState, useRef, memo, useCallback, useReducer } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import cx from "classnames";
import { compareAsc, format, addDays, addMonths } from 'date-fns'
// Provider
import { AppContext } from "../../components/AppProvider";

// Utils
import { _O, _CHECK } from "../../modules/utils";

// UI
import { IC, Doctor } from "../../resources/Assets";
import { ContainerNew, openLayerFn, closeLayerFn, MenuNone, CloseMenu } from "../Layout";

import { PostApi151 } from "../../modules/network/padoPost";

import { AlertLayer, ConfirmLayer } from "../../components/UI/Dialog";
import { ExistIdLayer } from "../common/Modal/ExistIdLayer";
import { userHabit } from "../../modules/utils/UserHabit";
import { NativeAction } from "../../modules/utils/HandleWs";

export default (props) => {
    const {userinfo, cfg, phonecfg} = useContext(AppContext);
    const [dupList, setDupList] = useState('');

    const [inputs, setInputs] = useState({
        email: '',
        password: ''
    });

    const {email, password} = inputs;

    const styleFindId = {
        display:"inline-block"
        , lineHeight:"1"
        , fontSize:"15px"
        , color:"#999"
        , borderBottom:"1px solid #999"
        , paddingBottom:"3px"
    }

    const handleChange = (e) => {
        const {name} = e.target;

        setInputs({
            ...inputs,
            [name]: e.target.value
        })
    };

    const handleReset = () => {
        setInputs({
            email: '',
            password: ''
        })
    }

    const handleFindPassword = () => {
        if ($("input[name='email']").val().trim().length === 0) {
            handleAlert('확인', '이메일을 입력해주세요.');
        } else if (!_CHECK.EmailCheck($("input[name='email']").val().trim())) {
            handleAlert('확인', '이메일 형식에 맞게 입력해 주세요.');
        } else {
            handleRequest151();
        }
    }

    const handleRequest151 = () => {
        PostApi151(phonecfg, cfg, $("input[name='email']").val())
            .then(res => {
                if (res.resultCode === '000') {
                    if (res.resultList.length === 0 || res.resultList[0].authkey === undefined) {
                        handleFindPasswordFail();
                        // reHandleRequest151();
                    } else if (res.resultList[0].isSNS === '1') {
                        handleSNSMember(res.resultList[0].signUpChannel);
                    } else {
                        checkAccountInfo(res);
                    }
                } else {
                    // setLoginSuccess(false);
                    handleFindPasswordFail();
                }
            })
            .catch(err => {
                console.log(err);
                handleFindPasswordFail();
            });
    }

    const reHandleRequest151 = () => {
        PostApi151(phonecfg, cfg, $("input[name='email']").val()+" ")
            .then(res => {
                console.log(res)
                if (res.resultCode === '000') {
                    if (res.resultList.length === 0 || res.resultList[0].authkey === undefined) {
                        handleFindPasswordFail();
                    } else if (res.resultList[0].isSNS === '1') {
                        handleSNSMember();
                    } else {
                        checkAccountInfo(res);
                    }
                } else {
                    handleFindPasswordFail();
                }
            })
            .catch(err => {
                console.log(err);
                handleFindPasswordFail();
            });
    }

    const checkAccountInfo = (res) => {
        if(res.resultList[0].signUpChannel === "000") {
            if(res.resultList[0].isAuthOk === '0') {
                // _O.OpenMenu(`/membership/newPwd/${res.resultList[0].authkey}/${res.paramValue.userEmail}`);
                _O.OpenMenu(`/membership/newPwd/${res.resultList[0].authkey}/${res.resultList[0].userEmail}`);
            } else {
                handleFindPasswordFail();
            }

            if(res.resultList[0].signUpChannel === "500") {
                _O.OpenMenu(`/membership/newPwd/${res.resultList[0].authkey}/${res.resultList[0].userEmail}`);
            }
        } else {
            _O.OpenMenu(`/membership/newPwd/${res.resultList[0].authkey}/${res.resultList[0].userEmail}`);
        }
    }

    const handleSNSMember = (signUpChannel) => {
        let snsType = "";
        if(signUpChannel === '100') {
            snsType = '네이버';
        } else {
            snsType = '카카오톡';
        }
        handleAlert('회원가입 여부 확인', 'SNS-' + snsType + '를(을) 통한 가입자입니다.');
    }

    const handleFindPasswordFail = () => {
        handleAlert('회원가입 여부 확인', '등록되지 않은 이메일 입니다.');
    }

    // 다이얼로그 [[
    const [dialog, setDialog] = useState({
        title: '',
        msg: ''
    })

    const handleAlert = (title, msg) => {
        setDialog({
            title: title,
            msg: msg
        })

        openLayerFn($(".alert-layer"));
    }

    const handleAlertCB = () => {
        // handleReset();
        closeLayerFn($(".alert-layer"));
    }
    // 다이얼로그 ]]

    const noSpaceInput = () => {
        const str_space = /\s/;

        if(str_space.exec($("input[name='email']").val())) {
            $("input[name='email']").val($("input[name='email']").val().replace(' ', ''));
        }
    }

    useEffect(()=>{
        userHabit(phonecfg, 'FP100');
        NativeAction(phonecfg, "statusColor", "#A5AEE4");
    }, [phonecfg.version]);

    return (
        <Fragment>
            <ContainerNew Title={ '비밀번호 재설정' } dark={true} leftMenu={MenuNone} rightMenu={CloseMenu} gotoRightUrl={'/membership/login'} >

                <div className="login-pw-box">

                    <div className="pw-inp-box">

                        <div className="ninp">
                            <input type="text"
                                name="email"
                                // value={email}
                                autoComplete="email"
                                placeholder="아이디"
                                onChange={noSpaceInput} />
                        </div>

                        <div className="btn">
                            <a href={void 0} className="btn-linkmail-layer" onClick={(e)=>handleFindPassword()}>확인</a>
                        </div>

                        <a style={styleFindId} onClick={(e) => _O.OpenMenu("/membership/findID")}>아이디 찾기</a>
                    </div>

                </div>
            </ContainerNew>

            <AlertLayer
                title={dialog.title}
                msg={dialog.msg}
                handleConfirmCB={handleAlertCB}
            />
            <ExistIdLayer dupList={dupList} />

        </Fragment>
    );
};